'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AvailabilityStatus;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

require('../styles/AvailabilityStatus.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function AvailabilityStatus(_ref) {
  var status = _ref.status,
      rollUpStatus = _ref.rollUpStatus,
      availabilityLocationType = _ref.availabilityLocationType,
      props = _objectWithoutProperties(_ref, ['status', 'rollUpStatus', 'availabilityLocationType']);

  return _react2.default.createElement(
    _reactIntl.FormattedMessage,
    {
      id: 'circ_' + (status ? status.toLowerCase() : rollUpStatus.toLowerCase()),
      values: { location: availabilityLocationType } },
    function (statusMessage) {
      return _react2.default.createElement(
        'span',
        _extends({}, props, { className: 'cp-availability-status ' + rollUpStatus.toLowerCase(), 'data-key': 'availability-status-' + rollUpStatus.toLowerCase() }),
        statusMessage
      );
    }
  );
}

AvailabilityStatus.propTypes = {
  status: _react.PropTypes.string.isRequired,
  rollUpStatus: _react.PropTypes.string.isRequired,
  availabilityLocationType: _react.PropTypes.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-status/lib/components/AvailabilityStatus.component.js
// module id = 686
// module chunks = 0 10 11 13 14